"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[600],{

/***/ 43749:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ getElementRef; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75271);
'use client';


function getElementRef(el) {
  const version = react__WEBPACK_IMPORTED_MODULE_0__.version;
  if (typeof version !== "string")
    return el?.ref;
  if (version.startsWith("18."))
    return el?.ref;
  return el?.props?.ref;
}




/***/ }),

/***/ 63651:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "y": function() { return /* binding */ PopoverContent; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.3.1/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52676);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+styled-system@2.12.4_react@18.3.1/node_modules/@chakra-ui/styled-system/dist/esm/define-styles.mjs
var define_styles = __webpack_require__(44719);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+utils@2.2.5_react@18.3.1/node_modules/@chakra-ui/utils/dist/esm/call-all.mjs
var call_all = __webpack_require__(25631);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+utils@2.2.5_react@18.3.1/node_modules/@chakra-ui/utils/dist/esm/cx.mjs
var cx = __webpack_require__(95558);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+react@2.10.9_@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1__@emot_2a5fdf7c628c94bdccf0335529e04f30/node_modules/@chakra-ui/react/dist/esm/popover/popover-context.mjs
var popover_context = __webpack_require__(36740);
// EXTERNAL MODULE: ./node_modules/.pnpm/framer-motion@6.5.1_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/framer-motion/dist/es/render/dom/motion.mjs + 166 modules
var motion = __webpack_require__(3276);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+react@2.10.9_@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1__@emot_2a5fdf7c628c94bdccf0335529e04f30/node_modules/@chakra-ui/react/dist/esm/system/factory.mjs
var factory = __webpack_require__(6793);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+react@2.10.9_@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1__@emot_2a5fdf7c628c94bdccf0335529e04f30/node_modules/@chakra-ui/react/dist/esm/system/forward-ref.mjs
var forward_ref = __webpack_require__(6579);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@chakra-ui+react@2.10.9_@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1__@emot_2a5fdf7c628c94bdccf0335529e04f30/node_modules/@chakra-ui/react/dist/esm/popover/popover-transition.mjs
'use client';






function mergeVariants(variants) {
  if (!variants)
    return;
  return {
    enter: {
      ...variants.enter,
      visibility: "visible"
    },
    exit: {
      ...variants.exit,
      transitionEnd: {
        visibility: "hidden"
      }
    }
  };
}
const scaleFade = {
  exit: {
    opacity: 0,
    scale: 0.95,
    transition: {
      duration: 0.1,
      ease: [0.4, 0, 1, 1]
    }
  },
  enter: {
    scale: 1,
    opacity: 1,
    transition: {
      duration: 0.15,
      ease: [0, 0, 0.2, 1]
    }
  }
};
const MotionSection = (0,factory/* chakra */.m)(motion/* motion.section */.E.section);
const PopoverTransition = (0,forward_ref/* forwardRef */.G)(function PopoverTransition2(props, ref) {
  const { variants = scaleFade, ...rest } = props;
  const { isOpen } = (0,popover_context/* usePopoverContext */.lp)();
  return /* @__PURE__ */ (0,jsx_runtime.jsx)(
    MotionSection,
    {
      ref,
      variants: mergeVariants(variants),
      initial: false,
      animate: isOpen ? "enter" : "exit",
      ...rest
    }
  );
});
PopoverTransition.displayName = "PopoverTransition";



;// CONCATENATED MODULE: ./node_modules/.pnpm/@chakra-ui+react@2.10.9_@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1__@emot_2a5fdf7c628c94bdccf0335529e04f30/node_modules/@chakra-ui/react/dist/esm/popover/popover-content.mjs
'use client';








const PopoverContent = (0,forward_ref/* forwardRef */.G)(
  function PopoverContent2(props, ref) {
    const { rootProps, motionProps, ...contentProps } = props;
    const { getPopoverProps, getPopoverPositionerProps, onAnimationComplete } = (0,popover_context/* usePopoverContext */.lp)();
    const styles = (0,popover_context/* usePopoverStyles */.SV)();
    const contentStyles = (0,define_styles/* defineStyle */.k0)({
      position: "relative",
      display: "flex",
      flexDirection: "column",
      ...styles.content
    });
    return /* @__PURE__ */ (0,jsx_runtime.jsx)(
      factory/* chakra.div */.m.div,
      {
        ...getPopoverPositionerProps(rootProps),
        __css: styles.popper,
        className: "chakra-popover__popper",
        children: /* @__PURE__ */ (0,jsx_runtime.jsx)(
          PopoverTransition,
          {
            ...motionProps,
            ...getPopoverProps(contentProps, ref),
            onAnimationComplete: (0,call_all/* callAll */.P)(
              onAnimationComplete,
              contentProps.onAnimationComplete
            ),
            className: (0,cx.cx)("chakra-popover__content", props.className),
            __css: contentStyles
          }
        )
      }
    );
  }
);
PopoverContent.displayName = "PopoverContent";




/***/ }),

/***/ 36740:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H2": function() { return /* binding */ PopoverProvider; },
/* harmony export */   "SV": function() { return /* binding */ usePopoverStyles; },
/* harmony export */   "WG": function() { return /* binding */ PopoverStylesProvider; },
/* harmony export */   "lp": function() { return /* binding */ usePopoverContext; }
/* harmony export */ });
/* harmony import */ var _chakra_ui_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54242);
'use client';


const [PopoverProvider, usePopoverContext] = (0,_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_0__/* .createContext */ .k)({
  name: "PopoverContext",
  errorMessage: "usePopoverContext: `context` is undefined. Seems you forgot to wrap all popover components within `<Popover />`"
});
const [PopoverStylesProvider, usePopoverStyles] = (0,_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_0__/* .createContext */ .k)({
  name: `PopoverStylesContext`,
  errorMessage: `usePopoverStyles returned is 'undefined'. Seems you forgot to wrap the components in "<Popover />" `
});




/***/ }),

/***/ 37973:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ PopoverTrigger; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52676);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75271);
/* harmony import */ var _popover_context_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36740);
/* harmony import */ var _element_ref_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43749);
'use client';





function PopoverTrigger(props) {
  const child = react__WEBPACK_IMPORTED_MODULE_1__.Children.only(props.children);
  const { getTriggerProps } = (0,_popover_context_mjs__WEBPACK_IMPORTED_MODULE_2__/* .usePopoverContext */ .lp)();
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: (0,react__WEBPACK_IMPORTED_MODULE_1__.cloneElement)(child, getTriggerProps(child.props, (0,_element_ref_mjs__WEBPACK_IMPORTED_MODULE_3__/* .getElementRef */ .e)(child))) });
}
PopoverTrigger.displayName = "PopoverTrigger";




/***/ }),

/***/ 25217:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "J": function() { return /* binding */ Popover; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.3.1/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52676);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+styled-system@2.12.4_react@18.3.1/node_modules/@chakra-ui/styled-system/dist/esm/theming-props.mjs
var theming_props = __webpack_require__(41902);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+utils@2.2.5_react@18.3.1/node_modules/@chakra-ui/utils/dist/esm/run-if-fn.mjs
var run_if_fn = __webpack_require__(19025);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+react@2.10.9_@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1__@emot_2a5fdf7c628c94bdccf0335529e04f30/node_modules/@chakra-ui/react/dist/esm/popover/popover-context.mjs
var popover_context = __webpack_require__(36740);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+hooks@2.4.5_react@18.3.1/node_modules/@chakra-ui/hooks/dist/esm/use-disclosure.mjs
var use_disclosure = __webpack_require__(46175);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+hooks@2.4.5_react@18.3.1/node_modules/@chakra-ui/hooks/dist/esm/use-animation-state.mjs
var use_animation_state = __webpack_require__(12880);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+hooks@2.4.5_react@18.3.1/node_modules/@chakra-ui/hooks/dist/esm/use-event-listener.mjs
var use_event_listener = __webpack_require__(22478);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@chakra-ui+hooks@2.4.5_react@18.3.1/node_modules/@chakra-ui/hooks/dist/esm/use-focus-on-pointer-down.mjs
'use client';


function isRefObject(val) {
  return "current" in val;
}
const isDom = () => typeof window !== "undefined";
function getPlatform() {
  const agent = navigator.userAgentData;
  return agent?.platform ?? navigator.platform;
}
const vn = (v) => isDom() && v.test(navigator.vendor);
const pt = (v) => isDom() && v.test(getPlatform());
const isApple = () => pt(/mac|iphone|ipad|ipod/i);
const isSafari = () => isApple() && vn(/apple/i);
function useFocusOnPointerDown(props) {
  const { ref, elements, enabled } = props;
  const doc = () => ref.current?.ownerDocument ?? document;
  (0,use_event_listener/* useEventListener */.O)(doc, "pointerdown", (event) => {
    if (!isSafari() || !enabled)
      return;
    const target = event.composedPath?.()?.[0] ?? event.target;
    const els = elements ?? [ref];
    const isValidTarget = els.some((elementOrRef) => {
      const el = isRefObject(elementOrRef) ? elementOrRef.current : elementOrRef;
      return el?.contains(target) || el === target;
    });
    if (doc().activeElement !== target && isValidTarget) {
      event.preventDefault();
      target.focus();
    }
  });
}



// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+hooks@2.4.5_react@18.3.1/node_modules/@chakra-ui/hooks/dist/esm/use-focus-effect.mjs
var use_focus_effect = __webpack_require__(19151);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+hooks@2.4.5_react@18.3.1/node_modules/@chakra-ui/hooks/dist/esm/use-outside-click.mjs
var use_outside_click = __webpack_require__(34105);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+hooks@2.4.5_react@18.3.1/node_modules/@chakra-ui/hooks/dist/esm/use-merge-refs.mjs
var use_merge_refs = __webpack_require__(88483);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+utils@2.2.5_react@18.3.1/node_modules/@chakra-ui/utils/dist/esm/tabbable.mjs
var tabbable = __webpack_require__(40886);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+utils@2.2.5_react@18.3.1/node_modules/@chakra-ui/utils/dist/esm/lazy.mjs
var lazy = __webpack_require__(96364);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+utils@2.2.5_react@18.3.1/node_modules/@chakra-ui/utils/dist/esm/call-all.mjs
var call_all = __webpack_require__(25631);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.3.1/node_modules/react/index.js
var react = __webpack_require__(75271);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+react@2.10.9_@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1__@emot_2a5fdf7c628c94bdccf0335529e04f30/node_modules/@chakra-ui/react/dist/esm/popper/use-popper.mjs + 56 modules
var use_popper = __webpack_require__(54202);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+react@2.10.9_@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1__@emot_2a5fdf7c628c94bdccf0335529e04f30/node_modules/@chakra-ui/react/dist/esm/popper/utils.mjs
var utils = __webpack_require__(8512);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@chakra-ui+react@2.10.9_@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1__@emot_2a5fdf7c628c94bdccf0335529e04f30/node_modules/@chakra-ui/react/dist/esm/popover/use-popover.mjs
'use client';






const TRIGGER = {
  click: "click",
  hover: "hover"
};
function usePopover(props = {}) {
  const {
    closeOnBlur = true,
    closeOnEsc = true,
    initialFocusRef,
    id,
    returnFocusOnClose = true,
    autoFocus = true,
    arrowSize,
    arrowShadowColor,
    trigger = TRIGGER.click,
    openDelay = 200,
    closeDelay = 200,
    isLazy,
    lazyBehavior = "unmount",
    computePositionOnMount,
    ...popperProps
  } = props;
  const { isOpen, onClose, onOpen, onToggle } = (0,use_disclosure/* useDisclosure */.q)(props);
  const [restoreFocus, setRestoreFocus] = (0,react.useState)(returnFocusOnClose);
  (0,react.useEffect)(() => setRestoreFocus(returnFocusOnClose), [returnFocusOnClose]);
  const anchorRef = (0,react.useRef)(null);
  const triggerRef = (0,react.useRef)(null);
  const popoverRef = (0,react.useRef)(null);
  const isHoveringRef = (0,react.useRef)(false);
  const hasBeenOpened = (0,react.useRef)(false);
  if (isOpen) {
    hasBeenOpened.current = true;
  }
  const [hasHeader, setHasHeader] = (0,react.useState)(false);
  const [hasBody, setHasBody] = (0,react.useState)(false);
  const uuid = (0,react.useId)();
  const uid = id ?? uuid;
  const [triggerId, popoverId, headerId, bodyId] = [
    "popover-trigger",
    "popover-content",
    "popover-header",
    "popover-body"
  ].map((id2) => `${id2}-${uid}`);
  const {
    referenceRef,
    getArrowProps,
    getPopperProps,
    getArrowInnerProps,
    forceUpdate
  } = (0,use_popper/* usePopper */.D)({
    ...popperProps,
    enabled: isOpen || !!computePositionOnMount
  });
  const animated = (0,use_animation_state/* useAnimationState */.h)({ isOpen, ref: popoverRef });
  useFocusOnPointerDown({
    enabled: isOpen,
    ref: triggerRef
  });
  (0,use_focus_effect/* useFocusOnHide */.C)(popoverRef, {
    focusRef: triggerRef,
    visible: isOpen,
    shouldFocus: restoreFocus && trigger === TRIGGER.click
  });
  (0,use_focus_effect/* useFocusOnShow */.G)(popoverRef, {
    focusRef: initialFocusRef,
    visible: isOpen,
    shouldFocus: autoFocus && trigger === TRIGGER.click
  });
  (0,use_outside_click/* useOutsideClick */.O)({
    enabled: isOpen && closeOnBlur,
    ref: popoverRef,
    handler(event) {
      const relatedTarget = event.composedPath?.()[0] ?? [
        event.target
      ];
      if (contains(triggerRef.current, relatedTarget))
        return;
      if (relatedTarget) {
        setRestoreFocus(!(0,tabbable/* isFocusable */.EB)(relatedTarget));
      }
      onClose();
    }
  });
  const shouldRenderChildren = (0,lazy/* lazyDisclosure */.k)({
    wasSelected: hasBeenOpened.current,
    enabled: isLazy,
    mode: lazyBehavior,
    isSelected: animated.present
  });
  const getPopoverProps = (0,react.useCallback)(
    (props2 = {}, _ref = null) => {
      const popoverProps = {
        ...props2,
        style: {
          ...props2.style,
          transformOrigin: utils/* cssVars.transformOrigin.varRef */.Dq.transformOrigin.varRef,
          [utils/* cssVars.arrowSize.var */.Dq.arrowSize["var"]]: arrowSize ? `${arrowSize}px` : void 0,
          [utils/* cssVars.arrowShadowColor.var */.Dq.arrowShadowColor["var"]]: arrowShadowColor
        },
        ref: (0,use_merge_refs/* mergeRefs */.lq)(popoverRef, _ref),
        children: shouldRenderChildren ? props2.children : null,
        id: popoverId,
        tabIndex: -1,
        role: "dialog",
        onKeyDown: (0,call_all/* callAllHandlers */.v)(props2.onKeyDown, (event) => {
          if (event.nativeEvent.isComposing)
            return;
          if (closeOnEsc && event.key === "Escape") {
            event.preventDefault();
            event.stopPropagation();
            onClose();
          }
        }),
        onBlur: (0,call_all/* callAllHandlers */.v)(props2.onBlur, (event) => {
          const relatedTarget = getRelatedTarget(event);
          const targetIsPopover = contains(popoverRef.current, relatedTarget);
          const targetIsTrigger = contains(triggerRef.current, relatedTarget);
          const isValidBlur = !targetIsPopover && !targetIsTrigger;
          if (relatedTarget) {
            setRestoreFocus(!(0,tabbable/* isFocusable */.EB)(relatedTarget));
          }
          if (isOpen && closeOnBlur && isValidBlur) {
            onClose();
          }
        }),
        "aria-labelledby": hasHeader ? headerId : void 0,
        "aria-describedby": hasBody ? bodyId : void 0
      };
      if (trigger === TRIGGER.hover) {
        popoverProps.role = "tooltip";
        popoverProps.onMouseEnter = (0,call_all/* callAllHandlers */.v)(props2.onMouseEnter, () => {
          isHoveringRef.current = true;
        });
        popoverProps.onMouseLeave = (0,call_all/* callAllHandlers */.v)(
          props2.onMouseLeave,
          (event) => {
            if (event.nativeEvent.relatedTarget === null) {
              return;
            }
            isHoveringRef.current = false;
            setTimeout(() => onClose(), closeDelay);
          }
        );
      }
      return popoverProps;
    },
    [
      shouldRenderChildren,
      popoverId,
      hasHeader,
      headerId,
      hasBody,
      bodyId,
      trigger,
      closeOnEsc,
      onClose,
      isOpen,
      closeOnBlur,
      closeDelay,
      arrowShadowColor,
      arrowSize
    ]
  );
  const getPopoverPositionerProps = (0,react.useCallback)(
    (props2 = {}, forwardedRef = null) => getPopperProps(
      {
        ...props2,
        style: {
          visibility: isOpen ? "visible" : "hidden",
          ...props2.style
        }
      },
      forwardedRef
    ),
    [isOpen, getPopperProps]
  );
  const getAnchorProps = (0,react.useCallback)(
    (props2, _ref = null) => {
      return {
        ...props2,
        // If anchor is rendered, it is used as reference.
        ref: (0,use_merge_refs/* mergeRefs */.lq)(_ref, anchorRef, referenceRef)
      };
    },
    [anchorRef, referenceRef]
  );
  const openTimeout = (0,react.useRef)(void 0);
  const closeTimeout = (0,react.useRef)(void 0);
  const maybeReferenceRef = (0,react.useCallback)(
    (node) => {
      if (anchorRef.current == null) {
        referenceRef(node);
      }
    },
    [referenceRef]
  );
  const getTriggerProps = (0,react.useCallback)(
    (props2 = {}, _ref = null) => {
      const triggerProps = {
        ...props2,
        ref: (0,use_merge_refs/* mergeRefs */.lq)(triggerRef, _ref, maybeReferenceRef),
        id: triggerId,
        "aria-haspopup": "dialog",
        "aria-expanded": isOpen,
        "aria-controls": popoverId
      };
      if (trigger === TRIGGER.click) {
        triggerProps.onClick = (0,call_all/* callAllHandlers */.v)(props2.onClick, onToggle);
      }
      if (trigger === TRIGGER.hover) {
        triggerProps.onFocus = (0,call_all/* callAllHandlers */.v)(props2.onFocus, () => {
          if (openTimeout.current === void 0) {
            onOpen();
          }
        });
        triggerProps.onBlur = (0,call_all/* callAllHandlers */.v)(props2.onBlur, (event) => {
          const relatedTarget = getRelatedTarget(event);
          const isValidBlur = !contains(popoverRef.current, relatedTarget);
          if (isOpen && closeOnBlur && isValidBlur) {
            onClose();
          }
        });
        triggerProps.onKeyDown = (0,call_all/* callAllHandlers */.v)(props2.onKeyDown, (event) => {
          if (event.key === "Escape") {
            onClose();
          }
        });
        triggerProps.onMouseEnter = (0,call_all/* callAllHandlers */.v)(props2.onMouseEnter, () => {
          isHoveringRef.current = true;
          openTimeout.current = window.setTimeout(() => onOpen(), openDelay);
        });
        triggerProps.onMouseLeave = (0,call_all/* callAllHandlers */.v)(props2.onMouseLeave, () => {
          isHoveringRef.current = false;
          if (openTimeout.current) {
            clearTimeout(openTimeout.current);
            openTimeout.current = void 0;
          }
          closeTimeout.current = window.setTimeout(() => {
            if (isHoveringRef.current === false) {
              onClose();
            }
          }, closeDelay);
        });
      }
      return triggerProps;
    },
    [
      triggerId,
      isOpen,
      popoverId,
      trigger,
      maybeReferenceRef,
      onToggle,
      onOpen,
      closeOnBlur,
      onClose,
      openDelay,
      closeDelay
    ]
  );
  (0,react.useEffect)(() => {
    return () => {
      if (openTimeout.current) {
        clearTimeout(openTimeout.current);
      }
      if (closeTimeout.current) {
        clearTimeout(closeTimeout.current);
      }
    };
  }, []);
  const getHeaderProps = (0,react.useCallback)(
    (props2 = {}, ref = null) => ({
      ...props2,
      id: headerId,
      ref: (0,use_merge_refs/* mergeRefs */.lq)(ref, (node) => {
        setHasHeader(!!node);
      })
    }),
    [headerId]
  );
  const getBodyProps = (0,react.useCallback)(
    (props2 = {}, ref = null) => ({
      ...props2,
      id: bodyId,
      ref: (0,use_merge_refs/* mergeRefs */.lq)(ref, (node) => {
        setHasBody(!!node);
      })
    }),
    [bodyId]
  );
  return {
    forceUpdate,
    isOpen,
    onAnimationComplete: animated.onComplete,
    onClose,
    getAnchorProps,
    getArrowProps,
    getArrowInnerProps,
    getPopoverPositionerProps,
    getPopoverProps,
    getTriggerProps,
    getHeaderProps,
    getBodyProps
  };
}
function contains(parent, child) {
  return parent === child || parent?.contains(child);
}
function getRelatedTarget(event) {
  const activeEl = event.currentTarget.ownerDocument.activeElement;
  return event.relatedTarget ?? activeEl;
}



// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+react@2.10.9_@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1__@emot_2a5fdf7c628c94bdccf0335529e04f30/node_modules/@chakra-ui/react/dist/esm/system/use-theme.mjs
var use_theme = __webpack_require__(69242);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+react@2.10.9_@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1__@emot_2a5fdf7c628c94bdccf0335529e04f30/node_modules/@chakra-ui/react/dist/esm/system/use-style-config.mjs + 1 modules
var use_style_config = __webpack_require__(54678);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@chakra-ui+react@2.10.9_@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1__@emot_2a5fdf7c628c94bdccf0335529e04f30/node_modules/@chakra-ui/react/dist/esm/popover/popover.mjs
'use client';








function Popover(props) {
  const styles = (0,use_style_config/* useMultiStyleConfig */.j)("Popover", props);
  const { children, ...rest } = (0,theming_props/* omitThemingProps */.L)(props);
  const theme = (0,use_theme/* useTheme */.F)();
  const context = usePopover({ ...rest, direction: theme.direction });
  return /* @__PURE__ */ (0,jsx_runtime.jsx)(popover_context/* PopoverProvider */.H2, { value: context, children: /* @__PURE__ */ (0,jsx_runtime.jsx)(popover_context/* PopoverStylesProvider */.WG, { value: styles, children: (0,run_if_fn/* runIfFn */.P)(children, {
    isOpen: context.isOpen,
    onClose: context.onClose,
    forceUpdate: context.forceUpdate
  }) }) });
}
Popover.displayName = "Popover";




/***/ }),

/***/ 48353:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "u": function() { return /* binding */ Tooltip; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.3.1/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52676);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+styled-system@2.12.4_react@18.3.1/node_modules/@chakra-ui/styled-system/dist/esm/theming-props.mjs
var theming_props = __webpack_require__(41902);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@chakra-ui+styled-system@2.12.4_react@18.3.1/node_modules/@chakra-ui/styled-system/dist/esm/get-css-var.mjs
function getCSSVar(theme, scale, value) {
  return theme.__cssMap?.[`${scale}.${value}`]?.varRef ?? value;
}



// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+utils@2.2.5_react@18.3.1/node_modules/@chakra-ui/utils/dist/esm/omit.mjs
var omit = __webpack_require__(8117);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+utils@2.2.5_react@18.3.1/node_modules/@chakra-ui/utils/dist/esm/pick.mjs
var pick = __webpack_require__(13646);
// EXTERNAL MODULE: ./node_modules/.pnpm/framer-motion@6.5.1_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/framer-motion/dist/es/render/dom/motion.mjs + 166 modules
var motion = __webpack_require__(3276);
// EXTERNAL MODULE: ./node_modules/.pnpm/framer-motion@6.5.1_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/framer-motion/dist/es/components/AnimatePresence/index.mjs + 1 modules
var AnimatePresence = __webpack_require__(63997);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.3.1/node_modules/react/index.js
var react = __webpack_require__(75271);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+react@2.10.9_@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1__@emot_2a5fdf7c628c94bdccf0335529e04f30/node_modules/@chakra-ui/react/dist/esm/element-ref.mjs
var element_ref = __webpack_require__(43749);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@chakra-ui+react@2.10.9_@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1__@emot_2a5fdf7c628c94bdccf0335529e04f30/node_modules/@chakra-ui/react/dist/esm/tooltip/tooltip.transition.mjs
'use client';
const scale = {
  exit: {
    scale: 0.85,
    opacity: 0,
    transition: {
      opacity: { duration: 0.15, easings: "easeInOut" },
      scale: { duration: 0.2, easings: "easeInOut" }
    }
  },
  enter: {
    scale: 1,
    opacity: 1,
    transition: {
      opacity: { easings: "easeOut", duration: 0.2 },
      scale: { duration: 0.2, ease: [0.175, 0.885, 0.4, 1.1] }
    }
  }
};



// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+hooks@2.4.5_react@18.3.1/node_modules/@chakra-ui/hooks/dist/esm/use-disclosure.mjs
var use_disclosure = __webpack_require__(46175);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+hooks@2.4.5_react@18.3.1/node_modules/@chakra-ui/hooks/dist/esm/use-event-listener.mjs
var use_event_listener = __webpack_require__(22478);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+hooks@2.4.5_react@18.3.1/node_modules/@chakra-ui/hooks/dist/esm/use-merge-refs.mjs
var use_merge_refs = __webpack_require__(88483);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+utils@2.2.5_react@18.3.1/node_modules/@chakra-ui/utils/dist/esm/is-element.mjs
var is_element = __webpack_require__(9670);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@chakra-ui+utils@2.2.5_react@18.3.1/node_modules/@chakra-ui/utils/dist/esm/scroll-parent.mjs


function isScrollParent(el) {
  const win = el.ownerDocument.defaultView || window;
  const { overflow, overflowX, overflowY } = win.getComputedStyle(el);
  return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}
function getParent(el) {
  if (el.localName === "html")
    return el;
  return el.assignedSlot || el.parentElement || el.ownerDocument.documentElement;
}
function getScrollParent(el) {
  if (["html", "body", "#document"].includes(el.localName)) {
    return el.ownerDocument.body;
  }
  if ((0,is_element/* isHTMLElement */.Re)(el) && isScrollParent(el)) {
    return el;
  }
  return getScrollParent(getParent(el));
}



// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+utils@2.2.5_react@18.3.1/node_modules/@chakra-ui/utils/dist/esm/call-all.mjs
var call_all = __webpack_require__(25631);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+react@2.10.9_@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1__@emot_2a5fdf7c628c94bdccf0335529e04f30/node_modules/@chakra-ui/react/dist/esm/popper/use-popper.mjs + 56 modules
var use_popper = __webpack_require__(54202);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+react@2.10.9_@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1__@emot_2a5fdf7c628c94bdccf0335529e04f30/node_modules/@chakra-ui/react/dist/esm/popper/utils.mjs
var utils = __webpack_require__(8512);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@chakra-ui+react@2.10.9_@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1__@emot_2a5fdf7c628c94bdccf0335529e04f30/node_modules/@chakra-ui/react/dist/esm/tooltip/use-tooltip.mjs
'use client';






const getDoc = (ref) => ref.current?.ownerDocument || document;
const getWin = (ref) => ref.current?.ownerDocument?.defaultView || window;
function useTooltip(props = {}) {
  const {
    openDelay = 0,
    closeDelay = 0,
    closeOnClick = true,
    closeOnMouseDown,
    closeOnScroll,
    closeOnPointerDown = closeOnMouseDown,
    closeOnEsc = true,
    onOpen: onOpenProp,
    onClose: onCloseProp,
    placement,
    id,
    isOpen: isOpenProp,
    defaultIsOpen,
    arrowSize = 10,
    arrowShadowColor,
    arrowPadding,
    modifiers,
    isDisabled,
    gutter,
    offset,
    direction,
    ...htmlProps
  } = props;
  const { isOpen, onOpen, onClose } = (0,use_disclosure/* useDisclosure */.q)({
    isOpen: isOpenProp,
    defaultIsOpen,
    onOpen: onOpenProp,
    onClose: onCloseProp
  });
  const { referenceRef, getPopperProps, getArrowInnerProps, getArrowProps } = (0,use_popper/* usePopper */.D)({
    enabled: isOpen,
    placement,
    arrowPadding,
    modifiers,
    gutter,
    offset,
    direction
  });
  const uuid = (0,react.useId)();
  const uid = id ?? uuid;
  const tooltipId = `tooltip-${uid}`;
  const ref = (0,react.useRef)(null);
  const enterTimeout = (0,react.useRef)(void 0);
  const clearEnterTimeout = (0,react.useCallback)(() => {
    if (enterTimeout.current) {
      clearTimeout(enterTimeout.current);
      enterTimeout.current = void 0;
    }
  }, []);
  const exitTimeout = (0,react.useRef)(void 0);
  const clearExitTimeout = (0,react.useCallback)(() => {
    if (exitTimeout.current) {
      clearTimeout(exitTimeout.current);
      exitTimeout.current = void 0;
    }
  }, []);
  const closeNow = (0,react.useCallback)(() => {
    clearExitTimeout();
    onClose();
  }, [onClose, clearExitTimeout]);
  const dispatchCloseEvent = useCloseEvent(ref, closeNow);
  const openWithDelay = (0,react.useCallback)(() => {
    if (!isDisabled && !enterTimeout.current) {
      if (isOpen)
        dispatchCloseEvent();
      const win = getWin(ref);
      enterTimeout.current = win.setTimeout(onOpen, openDelay);
    }
  }, [dispatchCloseEvent, isDisabled, isOpen, onOpen, openDelay]);
  const closeWithDelay = (0,react.useCallback)(() => {
    clearEnterTimeout();
    const win = getWin(ref);
    exitTimeout.current = win.setTimeout(closeNow, closeDelay);
  }, [closeDelay, closeNow, clearEnterTimeout]);
  const onClick = (0,react.useCallback)(() => {
    if (isOpen && closeOnClick) {
      closeWithDelay();
    }
  }, [closeOnClick, closeWithDelay, isOpen]);
  const onPointerDown = (0,react.useCallback)(() => {
    if (isOpen && closeOnPointerDown) {
      closeWithDelay();
    }
  }, [closeOnPointerDown, closeWithDelay, isOpen]);
  const onKeyDown = (0,react.useCallback)(
    (event) => {
      if (isOpen && event.key === "Escape") {
        closeWithDelay();
      }
    },
    [isOpen, closeWithDelay]
  );
  (0,use_event_listener/* useEventListener */.O)(
    () => getDoc(ref),
    "keydown",
    closeOnEsc ? onKeyDown : void 0
  );
  (0,use_event_listener/* useEventListener */.O)(
    () => {
      if (!closeOnScroll)
        return null;
      const node = ref.current;
      if (!node)
        return null;
      const scrollParent = getScrollParent(node);
      return scrollParent.localName === "body" ? getWin(ref) : scrollParent;
    },
    "scroll",
    () => {
      if (isOpen && closeOnScroll) {
        closeNow();
      }
    },
    { passive: true, capture: true }
  );
  (0,react.useEffect)(() => {
    if (!isDisabled)
      return;
    clearEnterTimeout();
    if (isOpen)
      onClose();
  }, [isDisabled, isOpen, onClose, clearEnterTimeout]);
  (0,react.useEffect)(() => {
    return () => {
      clearEnterTimeout();
      clearExitTimeout();
    };
  }, [clearEnterTimeout, clearExitTimeout]);
  (0,use_event_listener/* useEventListener */.O)(() => ref.current, "pointerleave", closeWithDelay);
  const getTriggerProps = (0,react.useCallback)(
    (props2 = {}, _ref = null) => {
      const triggerProps = {
        ...props2,
        ref: (0,use_merge_refs/* mergeRefs */.lq)(ref, _ref, referenceRef),
        onPointerEnter: (0,call_all/* callAllHandlers */.v)(props2.onPointerEnter, (e) => {
          if (e.pointerType === "touch")
            return;
          openWithDelay();
        }),
        onClick: (0,call_all/* callAllHandlers */.v)(props2.onClick, onClick),
        onPointerDown: (0,call_all/* callAllHandlers */.v)(props2.onPointerDown, onPointerDown),
        onFocus: (0,call_all/* callAllHandlers */.v)(props2.onFocus, openWithDelay),
        onBlur: (0,call_all/* callAllHandlers */.v)(props2.onBlur, closeWithDelay),
        "aria-describedby": isOpen ? tooltipId : void 0
      };
      return triggerProps;
    },
    [
      openWithDelay,
      closeWithDelay,
      onPointerDown,
      isOpen,
      tooltipId,
      onClick,
      referenceRef
    ]
  );
  const getTooltipPositionerProps = (0,react.useCallback)(
    (props2 = {}, forwardedRef = null) => getPopperProps(
      {
        ...props2,
        style: {
          ...props2.style,
          [utils/* cssVars.arrowSize.var */.Dq.arrowSize["var"]]: arrowSize ? `${arrowSize}px` : void 0,
          [utils/* cssVars.arrowShadowColor.var */.Dq.arrowShadowColor["var"]]: arrowShadowColor
        }
      },
      forwardedRef
    ),
    [getPopperProps, arrowSize, arrowShadowColor]
  );
  const getTooltipProps = (0,react.useCallback)(
    (props2 = {}, ref2 = null) => {
      const styles = {
        ...props2.style,
        position: "relative",
        transformOrigin: utils/* cssVars.transformOrigin.varRef */.Dq.transformOrigin.varRef
      };
      return {
        ref: ref2,
        ...htmlProps,
        ...props2,
        id: tooltipId,
        role: "tooltip",
        style: styles
      };
    },
    [htmlProps, tooltipId]
  );
  return {
    isOpen,
    show: openWithDelay,
    hide: closeWithDelay,
    getTriggerProps,
    getTooltipProps,
    getTooltipPositionerProps,
    getArrowProps,
    getArrowInnerProps
  };
}
const closeEventName = "chakra-ui:close-tooltip";
function useCloseEvent(ref, close) {
  (0,react.useEffect)(() => {
    const doc = getDoc(ref);
    doc.addEventListener(closeEventName, close);
    return () => doc.removeEventListener(closeEventName, close);
  }, [close, ref]);
  return () => {
    const doc = getDoc(ref);
    const win = getWin(ref);
    doc.dispatchEvent(new win.CustomEvent(closeEventName));
  };
}



// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+react@2.10.9_@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1__@emot_2a5fdf7c628c94bdccf0335529e04f30/node_modules/@chakra-ui/react/dist/esm/system/use-theme.mjs
var use_theme = __webpack_require__(69242);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+react@2.10.9_@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1__@emot_2a5fdf7c628c94bdccf0335529e04f30/node_modules/@chakra-ui/react/dist/esm/portal/portal.mjs
var portal = __webpack_require__(796);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+react@2.10.9_@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1__@emot_2a5fdf7c628c94bdccf0335529e04f30/node_modules/@chakra-ui/react/dist/esm/system/factory.mjs
var factory = __webpack_require__(6793);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+react@2.10.9_@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1__@emot_2a5fdf7c628c94bdccf0335529e04f30/node_modules/@chakra-ui/react/dist/esm/system/forward-ref.mjs
var forward_ref = __webpack_require__(6579);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+react@2.10.9_@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1__@emot_2a5fdf7c628c94bdccf0335529e04f30/node_modules/@chakra-ui/react/dist/esm/system/use-style-config.mjs + 1 modules
var use_style_config = __webpack_require__(54678);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@chakra-ui+react@2.10.9_@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1__@emot_2a5fdf7c628c94bdccf0335529e04f30/node_modules/@chakra-ui/react/dist/esm/tooltip/tooltip.mjs
'use client';















const MotionDiv = (0,factory/* chakra */.m)(motion/* motion.div */.E.div);
const Tooltip = (0,forward_ref/* forwardRef */.G)((props, ref) => {
  const styles = (0,use_style_config/* useStyleConfig */.m)("Tooltip", props);
  const ownProps = (0,theming_props/* omitThemingProps */.L)(props);
  const theme = (0,use_theme/* useTheme */.F)();
  const {
    children,
    label,
    shouldWrapChildren,
    "aria-label": ariaLabel,
    hasArrow,
    bg,
    portalProps,
    background,
    backgroundColor,
    bgColor,
    motionProps,
    animatePresenceProps,
    ...rest
  } = ownProps;
  const userDefinedBg = background ?? backgroundColor ?? bg ?? bgColor;
  if (userDefinedBg) {
    styles.bg = userDefinedBg;
    const bgVar = getCSSVar(theme, "colors", userDefinedBg);
    styles[utils/* cssVars.arrowBg.var */.Dq.arrowBg["var"]] = bgVar;
  }
  const tooltip = useTooltip({ ...rest, direction: theme.direction });
  const shouldWrap = !(0,react.isValidElement)(children) || shouldWrapChildren;
  let trigger;
  if (shouldWrap) {
    trigger = /* @__PURE__ */ (0,jsx_runtime.jsx)(
      factory/* chakra.span */.m.span,
      {
        display: "inline-block",
        tabIndex: 0,
        ...tooltip.getTriggerProps(),
        children
      }
    );
  } else {
    const child = react.Children.only(children);
    trigger = (0,react.cloneElement)(
      child,
      tooltip.getTriggerProps(child.props, (0,element_ref/* getElementRef */.e)(child))
    );
  }
  const hasAriaLabel = !!ariaLabel;
  const _tooltipProps = tooltip.getTooltipProps({}, ref);
  const tooltipProps = hasAriaLabel ? (0,omit/* omit */.C)(_tooltipProps, ["role", "id"]) : _tooltipProps;
  const srOnlyProps = (0,pick/* pick */.e)(_tooltipProps, ["role", "id"]);
  if (!label) {
    return /* @__PURE__ */ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, { children });
  }
  return /* @__PURE__ */ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, { children: [
    trigger,
    /* @__PURE__ */ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, { ...animatePresenceProps, children: tooltip.isOpen && /* @__PURE__ */ (0,jsx_runtime.jsx)(portal/* Portal */.h, { ...portalProps, children: /* @__PURE__ */ (0,jsx_runtime.jsx)(
      factory/* chakra.div */.m.div,
      {
        ...tooltip.getTooltipPositionerProps(),
        __css: {
          zIndex: styles.zIndex,
          pointerEvents: "none"
        },
        children: /* @__PURE__ */ (0,jsx_runtime.jsxs)(
          MotionDiv,
          {
            variants: scale,
            initial: "exit",
            animate: "enter",
            exit: "exit",
            ...motionProps,
            ...tooltipProps,
            __css: styles,
            children: [
              label,
              hasAriaLabel && /* @__PURE__ */ (0,jsx_runtime.jsx)(factory/* chakra.span */.m.span, { srOnly: true, ...srOnlyProps, children: ariaLabel }),
              hasArrow && /* @__PURE__ */ (0,jsx_runtime.jsx)(
                factory/* chakra.div */.m.div,
                {
                  "data-popper-arrow": true,
                  className: "chakra-tooltip__arrow-wrapper",
                  children: /* @__PURE__ */ (0,jsx_runtime.jsx)(
                    factory/* chakra.div */.m.div,
                    {
                      "data-popper-arrow-inner": true,
                      className: "chakra-tooltip__arrow",
                      __css: { bg: styles.bg }
                    }
                  )
                }
              )
            ]
          }
        )
      }
    ) }) })
  ] });
});
Tooltip.displayName = "Tooltip";




/***/ }),

/***/ 26801:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ Heading; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52676);
/* harmony import */ var _chakra_ui_styled_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41902);
/* harmony import */ var _chakra_ui_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(95558);
/* harmony import */ var _system_forward_ref_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6579);
/* harmony import */ var _system_use_style_config_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54678);
/* harmony import */ var _system_factory_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6793);
'use client';







const Heading = (0,_system_forward_ref_mjs__WEBPACK_IMPORTED_MODULE_1__/* .forwardRef */ .G)(
  function Heading2(props, ref) {
    const styles = (0,_system_use_style_config_mjs__WEBPACK_IMPORTED_MODULE_2__/* .useStyleConfig */ .m)("Heading", props);
    const { className, ...rest } = (0,_chakra_ui_styled_system__WEBPACK_IMPORTED_MODULE_3__/* .omitThemingProps */ .L)(props);
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
      _system_factory_mjs__WEBPACK_IMPORTED_MODULE_4__/* .chakra.h2 */ .m.h2,
      {
        ref,
        className: (0,_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_5__.cx)("chakra-heading", props.className),
        ...rest,
        __css: styles
      }
    );
  }
);
Heading.displayName = "Heading";




/***/ })

}]);